// src/pages/InventoryPage.js
import React, { useState, useEffect } from 'react';
import { getInventory, getStores } from '../api/apiService';

const bs = { fontFamily: "'Montserrat', sans-serif" };
const ds = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

const InventoryPage = () => {
  const [inventory,       setInventory]       = useState([]);
  const [stores,          setStores]          = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState('');
  const [search,          setSearch]          = useState('');
  const [loading,         setLoading]         = useState(true);
  const [expanded,        setExpanded]        = useState({}); // { productName: bool }

  useEffect(() => {
    (async () => {
      try {
        const [invData, storesData] = await Promise.all([getInventory(), getStores()]);
        setInventory(invData);
        setStores(storesData);
      } catch (err) {
        console.error('Error cargando inventario:', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // Filtrar por tienda
  const filtered = inventory.filter(item =>
    !selectedStoreId || item.store_id === Number(selectedStoreId)
  );

  // Agrupar por producto
  const byProduct = filtered.reduce((acc, item) => {
    const key = item.product_name;
    if (!acc[key]) acc[key] = { product_name: key, product_id: item.product_id, items: [] };
    acc[key].items.push(item);
    return acc;
  }, {});

  // Filtrar por búsqueda
  const products = Object.values(byProduct).filter(p =>
    !search || p.product_name.toLowerCase().includes(search.toLowerCase())
  );

  const totalUnits = filtered.reduce((s, i) => s + i.stock, 0);

  const toggleExpand = (name) => {
    setExpanded(prev => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <div style={{ padding: '24px 16px', maxWidth: '1000px', margin: '0 auto' }}>

      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ ...ds, fontSize: '2rem', fontWeight: 400, color: '#060D14', margin: '0 0 4px' }}>
          Inventario
        </h1>
        <p style={{ ...bs, fontSize: '12px', color: '#bbb', margin: 0 }}>
          {products.length} producto{products.length !== 1 ? 's' : ''} · {totalUnits} unidades totales
        </p>
      </div>

      {/* Filtros */}
      <div style={{ background: 'white', border: '1px solid #f0eaea',
        padding: '16px 20px', borderRadius: '2px', marginBottom: '16px',
        display: 'flex', gap: '14px', flexWrap: 'wrap', alignItems: 'flex-end' }}>

        <div style={{ flex: '1', minWidth: '160px' }}>
          <label style={{ ...bs, display: 'block', fontSize: '10px', letterSpacing: '0.18em',
            textTransform: 'uppercase', color: '#999', marginBottom: '6px' }}>Tienda</label>
          <select value={selectedStoreId} onChange={e => setSelectedStoreId(e.target.value)}
            style={{ ...bs, width: '100%', padding: '9px 12px', border: '1px solid #e5e0e0',
              fontSize: '12px', color: '#060D14', outline: 'none', borderRadius: '2px',
              background: 'white' }}
            onFocus={e => e.target.style.borderColor = '#961914'}
            onBlur={e => e.target.style.borderColor = '#e5e0e0'}>
            <option value="">Todas las tiendas</option>
            {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>

        <div style={{ flex: '2', minWidth: '200px', position: 'relative' }}>
          <label style={{ ...bs, display: 'block', fontSize: '10px', letterSpacing: '0.18em',
            textTransform: 'uppercase', color: '#999', marginBottom: '6px' }}>Buscar</label>
          <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="#bbb"
            style={{ position: 'absolute', left: '10px', bottom: '10px' }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          <input value={search} onChange={e => setSearch(e.target.value)}
            placeholder="Nombre del producto…"
            style={{ ...bs, width: '100%', padding: '9px 12px 9px 30px',
              border: '1px solid #e5e0e0', fontSize: '12px', color: '#060D14',
              outline: 'none', borderRadius: '2px', boxSizing: 'border-box' }}
            onFocus={e => e.target.style.borderColor = '#961914'}
            onBlur={e => e.target.style.borderColor = '#e5e0e0'} />
        </div>
      </div>

      {/* Tabla */}
      <div style={{ background: 'white', border: '1px solid #f0eaea',
        borderRadius: '2px', overflow: 'hidden' }}>

        {/* Header tabla */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px 100px 40px',
          padding: '10px 20px', background: '#faf9f9', borderBottom: '1px solid #f0eaea' }}>
          {['Producto', 'Variantes', 'Stock Total', ''].map(h => (
            <span key={h} style={{ ...bs, fontSize: '10px', fontWeight: 600,
              letterSpacing: '0.18em', textTransform: 'uppercase', color: '#bbb' }}>
              {h}
            </span>
          ))}
        </div>

        {loading ? (
          <div style={{ padding: '48px', textAlign: 'center' }}>
            <p style={{ ...bs, fontSize: '12px', color: '#bbb' }}>Cargando inventario…</p>
          </div>
        ) : products.length === 0 ? (
          <div style={{ padding: '48px', textAlign: 'center' }}>
            <p style={{ ...bs, fontSize: '12px', color: '#bbb' }}>No hay registros para mostrar.</p>
          </div>
        ) : (
          products.map((prod, idx) => {
            const totalStock  = prod.items.reduce((s, i) => s + i.stock, 0);
            const isLow       = prod.items.some(i => i.stock <= 5);
            const isExpanded  = expanded[prod.product_name];
            const varCount    = prod.items.length;

            return (
              <div key={prod.product_name}>
                {/* Fila producto */}
                <div
                  onClick={() => toggleExpand(prod.product_name)}
                  style={{
                    display: 'grid', gridTemplateColumns: '1fr 100px 100px 40px',
                    padding: '14px 20px', alignItems: 'center', cursor: 'pointer',
                    borderBottom: isExpanded ? '1px solid #f0eaea' : (idx < products.length - 1 ? '1px solid #faf5f5' : 'none'),
                    background: isExpanded ? '#fdf8f8' : (idx % 2 === 0 ? 'white' : '#fdfafa'),
                    transition: 'background 0.15s',
                  }}
                  onMouseOver={e => { if (!isExpanded) e.currentTarget.style.background = '#fdf5f5'; }}
                  onMouseOut={e => { if (!isExpanded) e.currentTarget.style.background = idx % 2 === 0 ? 'white' : '#fdfafa'; }}>

                  {/* Nombre */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {isLow && (
                      <svg width="12" height="12" fill="#dc2626" viewBox="0 0 20 20" style={{ flexShrink: 0 }}>
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd"/>
                      </svg>
                    )}
                    <span style={{ ...ds, fontSize: '1rem', fontWeight: 600, color: '#060D14' }}>
                      {prod.product_name}
                    </span>
                  </div>

                  {/* Variantes count */}
                  <span style={{ ...bs, fontSize: '12px', color: '#bbb' }}>
                    {varCount} variante{varCount !== 1 ? 's' : ''}
                  </span>

                  {/* Stock total */}
                  <span style={{ ...bs, fontSize: '14px', fontWeight: 700,
                    color: isLow ? '#dc2626' : '#060D14' }}>
                    {totalStock}
                  </span>

                  {/* Chevron */}
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="#bbb"
                      style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s' }}>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/>
                    </svg>
                  </div>
                </div>

                {/* Detalle expandido */}
                {isExpanded && (
                  <div style={{ background: '#fdfafa', borderBottom: idx < products.length - 1 ? '1px solid #f0eaea' : 'none' }}>

                    {/* Sub-header */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 120px 80px',
                      padding: '8px 20px 8px 48px', borderBottom: '1px solid #f5f0f0' }}>
                      {['Variante', 'Tienda', 'Stock'].map(h => (
                        <span key={h} style={{ ...bs, fontSize: '9px', fontWeight: 700,
                          letterSpacing: '0.18em', textTransform: 'uppercase', color: '#ccc' }}>
                          {h}
                        </span>
                      ))}
                    </div>

                    {prod.items.map((item, ii) => {
                      const storeName = stores.find(s => s.id === item.store_id)?.name || '—';
                      const lowItem   = item.stock <= 5;
                      return (
                        <div key={`${item.product_id}-${item.variant_id || 'base'}-${item.store_id}`}
                          style={{ display: 'grid', gridTemplateColumns: '1fr 120px 80px',
                            padding: '10px 20px 10px 48px',
                            borderBottom: ii < prod.items.length - 1 ? '1px solid #f8f5f5' : 'none',
                            background: ii % 2 === 0 ? 'transparent' : 'rgba(0,0,0,0.01)' }}>

                          {/* Variante */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ width: '3px', height: '3px', borderRadius: '50%',
                              background: '#e5c9c9', flexShrink: 0 }} />
                            <span style={{ ...bs, fontSize: '12px', color: '#666' }}>
                              {item.variant_size
                                ? `Talla ${item.variant_size}${item.variant_color ? ` · ${item.variant_color}` : ''}`
                                : '—'}
                            </span>
                          </div>

                          {/* Tienda */}
                          <span style={{ ...bs, fontSize: '11px', color: '#aaa' }}>
                            {storeName}
                          </span>

                          {/* Stock */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ ...bs, fontSize: '13px', fontWeight: 600,
                              color: lowItem ? '#dc2626' : '#16a34a' }}>
                              {item.stock}
                            </span>
                            {lowItem && (
                              <span style={{ ...bs, fontSize: '9px', color: '#dc2626',
                                fontWeight: 600, letterSpacing: '0.1em' }}>
                                BAJO
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* Hint */}
      {!loading && products.length > 0 && (
        <p style={{ ...bs, fontSize: '11px', color: '#ccc', textAlign: 'center',
          marginTop: '12px' }}>
          Toca cualquier producto para ver el detalle por variante y tienda
        </p>
      )}
    </div>
  );
};

export default InventoryPage;
